import Vue from 'vue'

import app from '@/globals/app'
Vue.use(app)

import breakpoint from '@/globals/breakpoint'
Vue.use(breakpoint)

import modal from '@/globals/modal'
Vue.use(modal)
